import {
  wrapperStyleType,
  IWidgetTheme,
  IBookingMenuOptionExtrasUpdater,
  ISimpleBookingOption,
} from 'shared-types/index';
import { GridSpacing } from '@material-ui/core/Grid';

export enum MenuOptionsState {
  DiaryLegacyState = "DiaryLegacyState",
  BookingCreator = "BookingCreator"
}

export interface IDispatchFromProps {
  handleDone?: (data: IBookingMenuOptionExtrasUpdater) => void;
}

export interface IStateFromProps {
  wrapperStyle: wrapperStyleType;
  theme: IWidgetTheme;
  currency: string; // AUD, GBP, USD, etc
  menuOptionsImplicit: ISimpleBookingOption[];
  menuOptionsExplicit: ISimpleBookingOption[];
  isUpsell?: boolean;
  isWideVersion?: boolean;
}

export interface IOwnProps {
  selectionData: IBookingMenuOptionExtrasUpdater;
  handleClose: (type: string) => void;
  gridGutter?: GridSpacing;
  stateType: MenuOptionsState; // we need this so that the internal-container (ChildMenuOptionOverlay) knows where the state is coming from
}

// this gets added to global store
export interface IActiveChildMenuOption {
  menuOptionsImplicit: ISimpleBookingOption[];
  menuOptionsExplicit: ISimpleBookingOption[];
}

export interface IParentMenuOption {
  id?: string; // "menuoption_UAQAZETMPS9T7_1573535792474"
  label: string;
  childMenuOptionIds?: string[];
  explicitChildMenuOptionIds?: string[];
}

export const classPrefix = 'ChildMenuOptionOverlay';